import Vue from 'vue'
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_VIVA

Vue.prototype.$http = axios

const success = response => response.data

Vue.prototype.$http.interceptors.response.use(success)